import styled from "styled-components";
import colours from "styles/colours";
import { resetButtonStyling } from "styles/commonStyles";
import fonts, { fontWeights } from "styles/fonts";

export const Header = styled.div`
  font-weight: ${fontWeights.heavy};
  color: ${colours.elexonBlack};
  font-size: ${fonts.mediumBigger};
`;

export const ToggleAllButtons = styled.div`
  display: flex;
  margin: 8px 3px;
  gap: 16px;
  > * {
    margin: 0 3px;
  }
`;

export const StyledDisabledText = styled.p`
  padding: 10px 5px 10px;
`;

export const StyledCategoryLabel = styled.div<{
  selected: boolean;
}>`
  font-weight: ${({ selected }): string => (selected ? "bold" : "normal")};
`;

export const StyledCategoryList = styled.dl`
  dt {
    display: inline;
  }

  dd {
    display: inline;
    float: right;
  }
`;

export const ToggleButton = styled.button`
  ${resetButtonStyling};
  color: ${colours.elexonBlue};

  &:hover {
    text-decoration: underline;
  }
`;
